import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";
// import leadReducer from "./audit/reducer"
import leadReducer from "./form/reducer"

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Lead:leadReducer,
});

export default rootReducer;
